import config from '../../../../config/config';
import { Configuration, PendencyTypesApi } from '../../../../generate/api';
import { store } from '../../../../redux/store';

export const pendencyTypesApi = new PendencyTypesApi(
    new Configuration({
        basePath: config.api.baseUrl,
        accessToken: () => {
            return store.getState().keycloak.token as string;
        },
    }),
);
